import { DocumentLibraryScreen } from '../documents/DocumentLibraryScreen.js';
import type { DocumentSource } from '../documents/source.js';
import type { LibraryDocument } from '../documents/types.js';
import type { InstructionOption } from './types.js';

/**
 * Job Card talimat seçicisinin seçenekleri [K38]: `pms_instructions` bölümünde bugün yürürlükte
 * (yayında) bir revizyonu olan ve geri çekilmemiş dokümanlar, numaraya göre. Taslak, onay
 * bekleyen ve geri çekilmiş doküman seçilmez (K16; `dokuman-kutuphanesi.md` §7).
 */
export function publishedInstructions(
  documents: readonly (Pick<LibraryDocument, 'id' | 'docNo' | 'title'> & {
    current: unknown;
    withdrawn?: unknown;
  })[],
): InstructionOption[] {
  return documents
    .filter((d) => d.current !== null && d.current !== undefined && !d.withdrawn)
    .map((d) => ({ id: d.id, docNo: d.docNo, title: d.title }))
    .sort((a, b) => a.docNo.localeCompare(b.docNo, 'en', { numeric: true }));
}

/**
 * Maintenance Plan ▸ Instructions sekmesi (plan M7 Task 14c; K38): M8a3'ün kütüphane ekranı
 * `pms_instructions` bölümüyle, sayfa içinde. Menü değişmez. Yazma (taslak, onay, yayın) yalnız
 * web ofiste; gemide salt okunur (kaynak kapsamı belirler).
 */
export function InstructionsTab({ source }: { source: DocumentSource }) {
  return <DocumentLibraryScreen section="pms_instructions" source={source} embedded />;
}
